import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * @author Tommaso Lazzaretti
 *
 * @description Crea un'istanza del servizio di debounce.
 * Il servizio utilizza un `Subject` di RxJS che emette valori con un ritardo specificato,
 * utile per gestire eventi che non devono essere eseguiti troppo frequentemente,
 * come input di ricerca o eventi di scroll.
 *
 * @param debounceTimeInMs - Il tempo di debounce in millisecondi.
 *                           Specifica quanto tempo deve trascorrere dopo l'ultimo evento
 *                           prima che l'evento venga effettivamente emesso.
 *                           Il valore predefinito è 300ms.
 */
export class DebounceUtility {
  private subject: Subject<any> = new Subject<any>();

  constructor(private debounceTimeInMs: number = 300) {}

  /**
   * Created using Rxjs operator DebounceTime
   * http://reactivex.io/rxjs/class/es6/Observable.js~Observable.html#instance-method-debounceTime
   * Returns a Subject object with debounce logic incorporated.
   * The emissions of the subject are delayed by a specified time during the instance creation.
   * @returns A Subject object with debounce logic.
   */
  get debouncedSubject(): Subject<any> {
    return this.subject.pipe(debounceTime(this.debounceTimeInMs)) as Subject<any>;
  }

  // Updated trigger method with optional parameters
  trigger(params?: any): void {
    this.subject.next(params);
  }

  complete(): void {
    this.subject.complete();
  }
}
